module.exports = new __parcel__URL__("confluence-try-end-learn.087e0017.svg").toString();